import { render, staticRenderFns } from "./Hospitals.vue?vue&type=template&id=3b8c7980&scoped=true"
import script from "./Hospitals.vue?vue&type=script&lang=js"
export * from "./Hospitals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8c7980",
  null
  
)

export default component.exports